var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","position":"absolute"}},[_c('div',{staticClass:"floating-map",class:{ 'large-map': _vm.isLarge }},[_c('PartyGuessMap',{attrs:{"canLarge":true},on:{"large":_vm.setLarge}})],1),_c('BattleTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }